<template>
  <div class="rubriques white-box position-relative">
    <TileLoader :loading="loading" />
    <h2>Rubriques fournisseur</h2>
    <ul class="rubrique-tabs" v-if="rubriquesGroups.length > 0">
      <li v-for="(group, i) of rubriquesGroups"
          :key="i"
          @click="selectedGroup = i"
          :class="{active: selectedGroup == i}">
        {{ group.GroupeLibelle }}
      </li>
    </ul>
    <ul class="rubriques-details"
        v-if="rubriquesGroups.length > selectedGroup && rubriquesGroups[selectedGroup] && rubriquesGroups[selectedGroup].rubriques">
      <li v-for="rubrique of rubriquesGroups[selectedGroup].rubriques"
          :key="rubrique.IdRubrique"
          :style="{backgroundColor: rubrique.CouleurFond, color: rubrique.CouleurTexte}">
        <a v-if="rubrique.url" :href="rubrique.url" target="_blank">
          {{ rubrique.Libelle }}
        </a>
        <a v-else @click="selectRubrique(rubrique)">
          {{ rubrique.Libelle }}
        </a>
      </li>
    </ul>

    <!-- Modal si plusieurs documents dans une rubriques
    = choix du document
  -->
    <Modal v-if="selectedRubrique" title="Documents" :open="selectedRubrique ? true : false"
           @close="selectedRubrique = null">
      <ul class="rubrique-document-list">
        <li v-for="doc of selectedRubrique.documents" :key="doc.Id">
          <a class="doc-title" :href="doc.url" target="_blank">
            {{ doc.Libelle }}
          </a>
          <small>
            {{ doc.Reference }}
            <span class="doc-publish-date">Le {{ formatDate(doc.DateAjout) }}</span>
          </small>
        </li>
      </ul>
    </Modal>
  </div>
</template>
<script>
import Modal from "../../Modal.vue";
import {getFrsRubriqueDocuments, getFrsRubriques} from "@/utils/frs";
import {getIntraRedirectUrl} from "@/helpers/getRedirectUrlHelper";
import dayjs from "dayjs";
import TileLoader from "../../Dashboards/TileLoader.vue";

export default {
  name: "FicheRdvRubriquesTile",
  components: {TileLoader, Modal},
  props: ["frsGuid"],
  data() {
    return {
      loading: 0,

      // Rubriques et groupes de l'Intranet
      rubriquesGroups: [],
      selectedGroup: 0,
      selectedRubrique: null,
    }
  },
  watch: {
    frsGuid() {
      this.getRubriques();
    }
  },
  mounted() {
    this.getRubriques();
  },
  methods: {
    // Récupération des rubriques fournisseur
    getRubriques() {
      if (!this.frsGuid) return;

      this.loading += 1;

      getFrsRubriques(this.frsGuid).then(res => {
        let result = [];
        let pList = [];

        // On donne le nom "Non défini" aux rubriques sans groupe
        // et on enlève les rubriques sans documents
        let tab = res
          .map(rubrique => ({
            ...rubrique,
            GroupeLibelle: rubrique.GroupeLibelle ? rubrique.GroupeLibelle : "Non défini"
          }))
          .filter(rubrique => rubrique.NbDoc != 0)

        // On regroupe les rubriques par groupe dans result
        tab.forEach(rubrique => {
          // On cherche le groupe par son id, dans result
          let group = result.find(grp => grp.IdGroupe == rubrique.IdGroupe)
          if (!group) { // Si le groupe n'existe pas encore, on l'ajoute
            result.push({
              IdGroupe: rubrique.IdGroupe,
              GroupeLibelle: rubrique.GroupeLibelle,
              GroupeOrdre: rubrique.GroupeOrdre,
              rubriques: [rubrique]
            });
          } else { // S'il existe déjà, on ajoute la rubrique à se lite de rubriques, puis on trie
            group.rubriques.push(rubrique);
            group.rubriques.sort((a, b) => a.Ordre - b.Ordre);
          }
        })

        // Pour chaque rubrique, on récupère lien du document associé, ou une liste de documents
        tab.forEach(rubrique => {
          const promise = new Promise((resolve) => {
            this.getRubriqueUrl(rubrique).then(([url, documents]) => {
              if (url) rubrique.url = url; // On récupère un lien
              else rubrique.documents = documents; // On récupère une liste de documents
              resolve();
            });
          });
          pList.push(promise);
        })

        Promise.all(pList).then(() => { // Une fois tous les documents chargés, on tri les groupes
          this.rubriquesGroups = result.sort((a, b) => a.GroupeOrdre - b.GroupeOrdre);
          this.loading -= 1;
        })
      })
    },

    // Récupère les URL de chaque rubrique pour afficher dans l'Intranet
    getRubriqueUrl(rubrique) { // récupère l'url d'une rubrique (url vers le document associé) ou la liste des documents associés
      return new Promise((resolve) => {
        if (rubrique.UrlRubrique) { // Si la rubrique ne possède qu'un document/lien: on redirige grace à l'intranet
          const url = new URL("https://cmem-mat.info/" + rubrique.UrlRubrique);
          url.searchParams.append("TiersId", rubrique.IdFournisseur);
          url.searchParams.append("RubriqueId", rubrique.IdRubrique);
          url.searchParams.delete("target");
          resolve([getIntraRedirectUrl(url.href.replace("https://cmem-mat.info/", "")), null]);
        } else { // S'il s'agit d'une liste de documents
          this.loading += 1;
          getFrsRubriqueDocuments(rubrique.IdFournisseur, rubrique.IdRubrique).then(res => { // On récupère les documents de la rubrique
            this.loading -= 1;
            if (res.length == 1) { // S'il n'y a qu'un document, on renvoie le lien du document
              resolve([getIntraRedirectUrl("/Pages/Commun/DocumentView.aspx?docId=" + res[0].Id), null]);
            } else { // On renvoie la liste des documents avec leur url
              res.forEach(doc => {
                doc.url = getIntraRedirectUrl("/Pages/Commun/DocumentView.aspx?docId=" + doc.Id);
              })
              resolve([null, res]);
            }
          });
        }
      })
    },

    // Sélection d'une rubrique
    selectRubrique(rubrique) {
      this.selectedRubrique = rubrique;
    },

    // Format de la date des documents des rubriques pour la modal
    formatDate(dateStr) {
      return dayjs(dateStr).format("DD/MM/YYYY HH:mm");
    },
  }
}
</script>

<style scoped>
.white-box {
  padding: 12px;
  flex: 1 1 70em;
}

h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

/* Rubriques */
.rubrique-tabs {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5em;
  /*row-gap: 12px;*/
  /*margin-top: 24px;*/
  border-bottom: 1px solid #EEE;
}

.rubrique-tabs li {
  padding: 2px 0;
  /*font-size: 1.2em;*/
  transition: all ease 230ms;
  border-bottom: 1px solid transparent;
}

.rubrique-tabs li:hover {
  cursor: pointer;
}

.rubrique-tabs li.active {
  color: #7ED321;
  border-bottom-color: #7ED321;
}

.rubriques-details {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  column-gap: 1.5em;
  row-gap: 12px;
  margin-top: 24px;
}

.rubriques-details li {
  border-radius: 6px;
  text-align: center;
}

.rubriques-details li a {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
  width: 100%;
  padding: 4px 16px;
}

.rubriques-details li a:hover {
  cursor: pointer;
}

.rubrique-document-list {
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 1em;
  list-style: none;
}

.rubrique-document-list li .doc-title {
  text-decoration: none;
}

.rubrique-document-list li .doc-title:hover {
  cursor: pointer;
}


.rubrique-document-list li small {
  display: flex;
  justify-content: space-between;
  font-size: 0.9em;
  color: #777;
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FicheRdvRubriquesTile.vue